// @ts-strict-ignore
import { ArrayUtils } from '@shared/util/array-utils';
import { ArticleContainerPropertyDef } from '@article/constants/article-container-property-def';
import { ArticleInfoVO } from '@project/model/vo/project.vo';

export class ArticleAttributeUtils {
  public static getRotationAngleFromArticleInfo(articleInfoVO: ArticleInfoVO): number {
    const attributes: string[] = this.getAttributeValueFromArticleInfo(articleInfoVO, ArticleContainerPropertyDef.TEXT_ANGLE);
    if (ArrayUtils.isEmpty(attributes)) {
      return 0;
    } else {
      return Number(attributes[0]);
    }
  }

  public static getAttributeValueFromArticleInfo(articleInfoVO: ArticleInfoVO, propertyName: string): string[] {
    let attributeValues: string[] = null;
    if (!articleInfoVO) {
      return null;
    }
    for (const attribute of articleInfoVO.attributes) {
      if (attribute.name === propertyName) {
        attributeValues = attribute.values;
        break;
      }
    }
    return attributeValues;
  }

  public static setAttributeValueFromArticleInfo(articleInfoVO: ArticleInfoVO, propertyName: string, attributeValues: string[]): void {
    for (const attribute of articleInfoVO.attributes) {
      if (attribute.name === propertyName) {
        attribute.values = attributeValues;
        break;
      }
    }
  }

  public static getArticlesGuidsBetweenAdaptersFromArticleInfo(articleInfoVO: ArticleInfoVO): string[] {
    return ArticleAttributeUtils.getAttributeValueFromArticleInfo(articleInfoVO, ArticleContainerPropertyDef.ARTICLES_GUIDS_BETWEEN_ADAPTERS);
  }
}
